"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NON_US_CA_NANP_NPAS = void 0;
exports.isUsOrCanadaNanpNpa = isUsOrCanadaNanpNpa;
/**
 * NANP NPAs that are not US or Canada (Caribbean, Atlantic, and Pacific territories).
 * +1 + 10 digits alone admits these high-cost SMS-pumping routes.
 *
 * Sources: NANPA territory assignments / Caribbean NANP NPAs.
 */
exports.NON_US_CA_NANP_NPAS = new Set(['242',
// Bahamas
'246',
// Barbados
'264',
// Anguilla
'268',
// Antigua and Barbuda
'284',
// British Virgin Islands
'340',
// US Virgin Islands
'345',
// Cayman Islands
'441',
// Bermuda
'473',
// Grenada
'649',
// Turks and Caicos
'658',
// Jamaica
'664',
// Montserrat
'670',
// Northern Mariana Islands
'671',
// Guam
'684',
// American Samoa
'721',
// Sint Maarten
'758',
// Saint Lucia
'767',
// Dominica
'784',
// Saint Vincent and the Grenadines
'787',
// Puerto Rico
'809',
// Dominican Republic
'829',
// Dominican Republic
'849',
// Dominican Republic
'868',
// Trinidad and Tobago
'869',
// Saint Kitts and Nevis
'876',
// Jamaica
'939' // Puerto Rico
]);
/** True when the 3-digit NPA is allocated to the US or Canada (not Caribbean/territory NANP). */
function isUsOrCanadaNanpNpa(npa) {
  return /^\d{3}$/.test(npa) && !exports.NON_US_CA_NANP_NPAS.has(npa);
}
//# sourceMappingURL=nanp-npa.js.map